export default "__VITE_ASSET__BfHOBy5R__"